import { Tag } from 'antd'

import { buildSearchFilterProps, sortStringColumn } from '../../../../components/tables/utils'
import { emptyCharacter } from '../../../../components/EmptyChar'

export const buildUsersTableColumns = () => [
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: sortStringColumn({ dataIndex: 'name' }),
    ...buildSearchFilterProps({ dataIndex: 'name' }),
  },
  {
    title: 'E-mail',
    dataIndex: 'email',
    sorter: sortStringColumn({ dataIndex: 'email' }),
    ...buildSearchFilterProps({ dataIndex: 'email' }),
  },
  {
    title: 'Status',
    dataIndex: 'userStatus',
    sorter: sortStringColumn({ dataIndex: 'userStatus' }),
    ...buildSearchFilterProps({ dataIndex: 'userStatus' }),
    render: renderUserStatusTag(),
  },
]

const renderUserStatusTag = () => (status: string) =>
  status ? (
    <Tag color={status === 'enabled' ? 'green' : 'red'} className="capitalize">
      {status}
    </Tag>
  ) : (
    emptyCharacter
  )
